/* eslint-disable
    default-case,
    guard-for-in,
    no-loop-func,
    no-restricted-syntax,
    no-var,
    one-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import AppDispatcher from 'lib/Dispatcher';
import * as browser from 'lib/Browser';
import {EventConstants} from 'constants/EventConstants';
import Store from 'lib/Store';
import {setupUser} from 'util/UserUtil';

class EntityStore extends Store {
  resetState() {
    this.entities = {};
    this.currentUserId = null;
    this.groupToPermissions = {};
    this.publicReferralIdsByEmail = {};
    if (browser.isBrowser && window.bootstrapUser != null) {
      setupUser(window.bootstrapUser);
      this.currentUserId = window.user.id;
      this.entities[this.currentUserId] = window.user;
      if (window.user.currentUserInboundRequests != null) {
        const currentUserInboundRequests = this.processServerOrgRequests(
          window.user.currentUserInboundRequests
        );
        this.mergeEntity(this.currentUserId, {currentUserInboundRequests});
      }
      if (window.bootstrapUserOrgs != null) {
        this.addOrgsForUser(this.currentUserId, window.bootstrapUserOrgs);
      }
      if (window.bootstrapUserTeams != null) {
        this.addTeamsForUser(this.currentUserId, window.bootstrapUserTeams);
      }
      const {referral} = window.bootstrapUser;
      this.mergeEntity(this.currentUserId, {referral});
      if ((window.bootstrap != null ? window.bootstrap.referrals : undefined) != null) {
        this.mergeEntity(this.currentUserId, {
          referrals: this.processServerReferrals(window.bootstrap.referrals),
        });
      }
    }
  }

  processStoreOrgRequests(requests) {
    if (requests == null) {
      return null;
    }
    return requests.map((req) =>
      _.extend(
        {
          organization: this.entities[req.organizationId],
          user: this.entities[req.userId],
          inviter: this.entities[req.inviterId],
        },
        req
      )
    );
  }

  processStoreReferrals(referrals) {
    if (referrals == null) {
      return null;
    }
    return referrals.map((referral) => {
      const user = referral.userId != null ? this.entities[referral.userId] : null;
      return _.extend({user}, referral);
    });
  }

  getPublicReferralId(email) {
    return this.publicReferralIdsByEmail[email];
  }

  getEntity(entityId) {
    let organizations, teams;
    const entity = this.entities[entityId];
    if (entity == null) {
      return null;
    }

    if (entity.organizationIds != null) {
      organizations = entity.organizationIds.map((orgId) => this.entities[orgId]);
    } else {
      organizations = null;
    }

    if (entity.teamIds != null) {
      teams = entity.teamIds.map((teamId) => this.entities[teamId]);
    } else {
      teams = null;
    }

    const currentUserInboundRequests = this.processStoreOrgRequests(entity.currentUserInboundRequests);
    const userOrgsInboundRequests = this.processStoreOrgRequests(entity.userOrgsInboundRequests);
    const referrals = this.processStoreReferrals(entity.referrals);
    return reactUpdate(entity, {
      $merge: {
        organizations,
        teams,
        currentUserInboundRequests,
        userOrgsInboundRequests,
        referrals,
      },
    });
  }

  getMembersForGroup(orgId) {
    if (!this.groupToPermissions[orgId]) {
      return null;
    }
    // Combine user and organization/team permission
    return this.groupToPermissions[orgId].map((permission) =>
      _.extend(
        {
          initials: permission.initials,
          // TODO(T8273): Use role rather than level.
          level: permission.level != null ? permission.level : permission.role,
        },
        this.entities[permission.userId]
      )
    );
  }

  addOrgsForUser(userId, orgs, param) {
    let update;
    if (param == null) {
      param = {};
    }
    let {append} = param;
    if (append == null) {
      append = false;
    }
    orgs.forEach((org) => {
      this.entities[org.id] = org;
    });
    const organizationIds = orgs.map((org) => org.id);
    if (
      append &&
      (this.entities[userId] != null ? this.entities[userId].organizationIds : undefined) != null
    ) {
      update = {organizationIds: {$push: organizationIds}};
    } else {
      update = {organizationIds: {$set: organizationIds}};
    }
    this.updateEntity(userId, update);
  }

  addTeamsForUser(userId, teams) {
    teams.forEach((team) => {
      this.entities[team.id] = team;
    });
    const teamIds = teams.map((team) => team.id);
    this.updateEntity(userId, {teamIds: {$set: teamIds}});
  }

  addMembersForGroup(entityId, members, permissions) {
    for (const member of Array.from(members)) {
      this.mergeEntity(member.id, member);
    }
    if (permissions) {
      this.groupToPermissions[entityId] = permissions;
    }
  }

  removeMemberFromGroup(entityId, userId) {
    this.groupToPermissions[entityId] = _.reject(
      this.groupToPermissions[entityId],
      (permission) => permission.userId === userId
    );
  }

  setOrgInitials(orgId, orgInitials) {
    this.updateEntity(orgId, {initials: {$set: orgInitials}});
  }

  setOrgMemberInitials(orgId, initialsByUserId) {
    for (var userId in initialsByUserId) {
      const initials = initialsByUserId[userId];
      const index = this.groupToPermissions[orgId].findIndex((permission) => permission.userId === userId);
      this.groupToPermissions[orgId] = reactUpdate(
        this.groupToPermissions[orgId],
        _.object([[index, {initials: {$set: initials}}]])
      );
    }
  }

  setMemberRole(entityId, userId, memberRole) {
    const index = this.groupToPermissions[entityId].findIndex((permission) => permission.userId === userId);
    this.groupToPermissions[entityId] = reactUpdate(
      this.groupToPermissions[entityId],
      _.object([[index, {level: {$set: memberRole}}]])
    );
  }

  currentUser() {
    if (this.currentUserId != null) {
      return this.getEntity(this.currentUserId);
    } else {
      return null;
    }
  }

  currentUserHasPendingInvites() {
    if (this.currentUser() == null) {
      return false;
    }

    const {currentUserInboundRequests, userOrgsInboundRequests, pendingOrgInvites} = this.currentUser();
    if (_.isEmpty(currentUserInboundRequests) && _.isEmpty(userOrgsInboundRequests) && !pendingOrgInvites) {
      return false;
    }
    return true;
  }

  currentUserIsAdminOfAnyOrg() {
    return this.currentUser()?.organizations?.some((org) => org?.admin) ?? false;
  }

  currentUserHasBenchlingEmail() {
    return this.currentUser()?.email?.endsWith('@benchling.com') ?? false;
  }

  mergeEntity(entityId, fields) {
    this.updateEntity(entityId, {$merge: fields});
  }

  updateEntity(entityId, update) {
    const entity = this.entities[entityId] || {id: entityId};
    this.entities[entityId] = reactUpdate(entity, update);
  }

  removeOrgRequest(orgId, userId) {
    for (const entityId in this.entities) {
      var index;
      const entity = this.entities[entityId];
      let userOrgsInboundRequests = entity.userOrgsInboundRequests || [];
      let currentUserInboundRequests = entity.currentUserInboundRequests || [];
      const requestMatches = (req) => req.organizationId === orgId && req.userId === userId;
      const userOrgInboundRequest = _.find(userOrgsInboundRequests, (req) => requestMatches(req));
      const currentUserInboundRequest = _.find(currentUserInboundRequests, (req) => requestMatches(req));

      if (userOrgInboundRequest != null) {
        index = userOrgsInboundRequests.indexOf(userOrgInboundRequest);
        userOrgsInboundRequests = reactUpdate(userOrgsInboundRequests, {$splice: [[index, 1]]});
        this.mergeEntity(entityId, {userOrgsInboundRequests});
      }
      if (currentUserInboundRequest != null) {
        index = currentUserInboundRequests.indexOf(currentUserInboundRequest);
        currentUserInboundRequests = reactUpdate(currentUserInboundRequests, {$splice: [[index, 1]]});
        this.mergeEntity(entityId, {currentUserInboundRequests});
      }
    }
  }

  // Strip out the orgs and users, and replace with ids.
  processServerOrgRequests(requests) {
    for (const request of Array.from(requests)) {
      this.mergeEntity(request.organization.id, request.organization);
      this.mergeEntity(request.user.id, request.user);
      if (request.inviter != null) {
        this.mergeEntity(request.inviter.id, request.inviter);
      }
    }

    return requests.map((request) => {
      const withoutDicts = _.omit(request, 'organization', 'user', 'inviter');
      return _.extend(withoutDicts, {
        organizationId: request.organization.id,
        userId: request.user.id,
        inviterId: request.inviter != null ? request.inviter.id : null,
      });
    });
  }

  processServerReferrals(referrals) {
    for (const referral of Array.from(referrals)) {
      if (referral.user != null) {
        this.mergeEntity(referral.user.id, referral.user);
      }
    }

    return referrals.map((referral) => {
      const withoutDicts = _.omit(referral, 'user');
      return _.extend(withoutDicts, {
        userId: (referral.user != null ? referral.user.id : undefined) || null,
      });
    });
  }

  payloadHandler(action) {
    let org;
    switch (action.actionType) {
      case EventConstants.ONBOARDING_FETCH_EXTRA_SPACE_TASKS_COMPLETED:
        this.mergeEntity(action.entityId, {extraSpaceTasks: action.extraSpaceTasks});
        this.emitChange();
        break;

      case EventConstants.ORG_FETCH_COMPLETED:
        this.addOrgsForUser(action.entityId, action.orgs);
        this.emitChange();
        break;

      case EventConstants.OPEN_ORGANIZATION_PAGE_COMPLETED:
        this.entities[action.organization.id] = action.organization;
        this.emitChange();
        break;

      case EventConstants.OPEN_TEAM_PAGE_COMPLETED:
        this.entities[action.team.id] = action.team;
        this.entities[action.organization.id] = action.organization;
        this.emitChange();
        break;

      case EventConstants.GROUP_MEMBERS_FETCH_COMPLETED:
        this.addMembersForGroup(action.entityId, action.members, action.permissions);
        this.emitChange();
        break;

      case EventConstants.OPEN_MEMBERS_TAB_COMPLETED:
        this.addMembersForGroup(action.entityId, action.members, action.permissions);
        if (action.organizationMemberRequests != null) {
          for (const request of Array.from(action.organizationMemberRequests)) {
            this.mergeEntity(request.user.id, request.user);
          }
        }
        this.emitChange();
        break;

      case EventConstants.MEMBER_REMOVAL_COMPLETED:
        this.removeMemberFromGroup(action.entityId, action.userId);
        this.emitChange();
        break;

      case EventConstants.USER_FETCH_ORG_REQUESTS_COMPLETED: {
        const currentUserInboundRequests = this.processServerOrgRequests(action.currentUserInboundRequests);
        const userOrgsInboundRequests = this.processServerOrgRequests(action.userOrgsInboundRequests);
        const currentUserOutboundRequests = this.processServerOrgRequests(action.currentUserOutboundRequests);
        this.mergeEntity(action.entityId, {
          currentUserInboundRequests,
          userOrgsInboundRequests,
          pendingOrgInvites: action.pendingOrgInvites,
          currentUserOutboundRequests,
        });
        this.emitChange();
        break;
      }

      case EventConstants.USER_DISMISS_ALL_ORG_INVITES:
        this.mergeEntity(action.userId, {pendingOrgInvites: 0});
        this.emitChange();
        break;

      case EventConstants.USER_DISMISS_ALL_ORG_INVITES_FAILED:
        this.mergeEntity(action.userId, {pendingOrgInvites: action.originalPendingInvites});
        this.emitChange();
        break;

      case EventConstants.ORG_CREATE_COMPLETED: {
        const {organization} = action;
        this.addOrgsForUser(this.currentUserId, [organization], {append: true});
        this.emitChange();
        break;
      }

      case EventConstants.ORG_INITIALS_UPDATE_COMPLETED: {
        const {orgId, orgInitials, initialsByUserId} = action;
        if (orgInitials != null) {
          this.setOrgInitials(orgId, orgInitials);
        }
        if (initialsByUserId) {
          this.setOrgMemberInitials(orgId, initialsByUserId);
        }
        this.emitChange();
        break;
      }
      case EventConstants.ORG_INITIALS_UPDATE_FAILED:
        // Any components listening to this store should be reset back to the original initials
        this.emitChange();
        break;

      case EventConstants.MEMBER_PERMISSION_UPDATE_COMPLETED:
        this.setMemberRole(action.entityId, action.userId, action.role);
        this.emitChange();
        break;

      case EventConstants.ORG_ACCEPT_REQUEST:
        org = this.entities[action.organizationId];
        this.addOrgsForUser(action.userId, [org], {append: true});
        this.removeOrgRequest(action.organizationId, action.userId);
        this.emitChange();
        break;

      case EventConstants.ORG_UPDATE_COMPLETED:
        this.updateEntity(this.currentUserId, {$merge: {disablePublic: action.organization.disablePublic}});
        this.emitChange();
        break;

      case EventConstants.TEAM_UPDATE_COMPLETED:
        this.mergeEntity(action.team.id, action.team);
        this.emitChange();
        break;

      case EventConstants.ORG_REJECT_REQUEST:
        this.removeOrgRequest(action.organizationId, action.userId);
        this.emitChange();
        break;

      case EventConstants.USER_ACCEPT_ORG_REQUEST:
        org = this.entities[action.organizationId];
        this.addOrgsForUser(action.userId, [org], {append: true});
        this.removeOrgRequest(action.organizationId, action.userId);
        this.emitChange();
        break;

      case EventConstants.USER_REJECT_ORG_REQUEST:
        this.removeOrgRequest(action.organizationId, action.userId);
        this.emitChange();
        break;

      case EventConstants.USER_FETCH_REFERRALS: {
        const referrals = this.processServerReferrals(action.referrals);
        this.mergeEntity(action.userId, {referrals});
        this.emitChange();
        break;
      }

      case EventConstants.USER_FETCH_REFERRAL_LINK_ID:
        this.publicReferralIdsByEmail = {
          ...this.publicReferralIdsByEmail,
          [action.email]: action.referralLinkId,
        };
        this.emitChange();
        break;

      case EventConstants.USER_FETCH_METADATA:
        this.mergeEntity(action.userId, {metadata: action.metadata});
        this.emitChange();
        break;
    }

    return true;
  }
}

export default new EntityStore(AppDispatcher);
